import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { SpeedInsights } from "@vercel/speed-insights/react"
import { Analytics } from "@vercel/analytics/react"

// Import i18n configuration
import './i18n'

const isProduction = import.meta.env.PROD;

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isProduction && <SpeedInsights />}
    {isProduction && <Analytics />}
    <App />
  </StrictMode>,
)
